module.exports = __webpack_public_path__ + "static/media/shiny-happy-people-mobile.03611fcc.svg";